import { render, staticRenderFns } from "./bloodTransfusions.vue?vue&type=template&id=560dc920&scoped=true"
import script from "./bloodTransfusions.vue?vue&type=script&lang=js"
export * from "./bloodTransfusions.vue?vue&type=script&lang=js"
import style0 from "./bloodTransfusions.vue?vue&type=style&index=0&id=560dc920&prod&lang=scss&scoped=true"
import style1 from "./bloodTransfusions.vue?vue&type=style&index=1&id=560dc920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560dc920",
  null
  
)

export default component.exports